var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const REGULAR_USER_AUTH = "api/auth";
export const getSessions = function () {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            return yield this.axiosInstance.get(`${REGULAR_USER_AUTH}/sessions`, {
                headers: { Authorization: `Bearer ${this.apiToken}` },
            });
        }
        catch (error) {
            throw error;
        }
    });
};
export const getSignupCountrySuggestion = function () {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {};
            return yield this.axiosInstance.get(`${REGULAR_USER_AUTH}/signup-country-suggestion`, config);
        }
        catch (error) {
            console.error("Error fetching getSignupCountrySuggestion:", error);
            throw error;
        }
    });
};
